import { Select } from "antd";
import { useEffect, useState } from "react";
import { SelectDropdown } from "themes/Icon";
import TagComp from "../Tag";
import { toast } from "react-toastify";

function ChipSelect({
  onChange,
  options,
  setRecipientsFlag,
  defaultValues,
  isEdit,
  isDuplicate,
}) {
  const [selectedValues, setSelectedValues] = useState();

  useEffect(() => {
    if (isEdit || isDuplicate) {
      setSelectedValues(
        defaultValues?.map((ward) =>
          ward.ward_code
            ? `${ward.ward_code} - ${ward.region_name}`
            : ward.value
        ) || []
      );
    }
  }, []);

  const handleChange = (newValues) => {
    const allCitizensSelected = newValues.includes("All citizens");

    if (allCitizensSelected) {
      const allCitizensOption = options.find(
        (option) => option.value === "All citizens"
      );
      if (newValues.length > 1) {
        toast.warning(`Cannot select wards while 'All citizens' is selected.`);
      }

      setSelectedValues([allCitizensOption.value]);
      onChange(["All citizens"]);
      setRecipientsFlag(1);
    } else {
      const updatedValues = newValues
        .map((id) => options.find((option) => option.value === id))
        .filter(Boolean);
      if (!updatedValues.length) {
        setSelectedValues([]);
        onChange([]);
        setRecipientsFlag(0);
      } else {
        setSelectedValues(updatedValues.map((option) => option.value));
        setRecipientsFlag(2);

        const formattedData = updatedValues.map((option) => ({
          ward_code: String(option.wardCode),
          ward_name: option.wardName,
          region_id: String(option.regionId),
          region_name: option.regionName,
        }));
        onChange(formattedData);
      }
    }
  };

  const tagRender = (props) => {
    const { label, onClose } = props;
    return <TagComp onClose={onClose}>{label}</TagComp>;
  };

  return (
    <div className="flex flex-column gap-2">
      <label className="input-label">Recipients</label>
      <Select
        mode="multiple"
        suffixIcon={<SelectDropdown />}
        allowClear
        tagRender={tagRender}
        style={{ width: "100%" }}
        className="chip-select"
        popupClassName="select-popover"
        placeholder="Select recipients"
        onChange={handleChange}
        value={selectedValues}
        defaultValue={defaultValues?.map((ward) => ({
          label: `${ward.ward_code} - ${ward.region_name}`,
          value: `${ward.ward_code} - ${ward.region_name}`,
        }))}
        options={options}
        maxTagCount={2}
        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
        filterOption={(input, option) =>
          option?.label.toLowerCase().includes(input.toLowerCase())
        }
      />
    </div>
  );
}

export default ChipSelect;
